var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { EventEmitter, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import * as moment from 'moment';
import { IntegrationImportColumn, Order } from "../../integration-imports.interface";
import { GetIntegrationImportsAction } from "../../integration-imports.actions";
import { getIntegrationImportsParamsSelector } from "../../integration-imports.reducer";
import { MatTableDataSource } from "@angular/material/table";
var IntegrationImportsTableComponent = /** @class */ (function () {
    function IntegrationImportsTableComponent(store) {
        this.store = store;
        this.displayedColumns = [
            'operation',
            'startDate',
            'finishDate',
            'status',
            'contactsCreated',
            'contactsUpdated',
            'contactsRejected',
            'integrationType',
        ];
        this.rejectedClicked = new EventEmitter();
    }
    IntegrationImportsTableComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.store.select(getIntegrationImportsParamsSelector).subscribe(function (params) {
            _this.params = params;
        });
    };
    IntegrationImportsTableComponent.prototype.sortChange = function ($event) {
        this.store.dispatch(new GetIntegrationImportsAction(__assign({}, this.params, { order: $event.direction ? Order[$event.direction.toUpperCase()] : null, sortBy: IntegrationImportColumn[$event.active] })));
    };
    IntegrationImportsTableComponent.prototype.formatDate = function (date) {
        if (date) {
            return moment(date).format('LT, l');
        }
        return '';
    };
    return IntegrationImportsTableComponent;
}());
export { IntegrationImportsTableComponent };
